import { Box, Stack, Typography } from '@mui/material'
import { useGeometryRaster } from '@cibo/mapgl'

const maptilesServiceUrl = import.meta.env.VITE_MAPTILES_SERVICE_URL

export const CDLHistory = ({ geometry, year }: any) => {
  const geometryRaster = useGeometryRaster(
    {
      tileUrl: `${maptilesServiceUrl}cdl/${year}/{z}/{y}/{x}.png`,
      tileSize: 256,
      zoomRange: {
        min: 6,
        max: 12,
      },
    },
    geometry
  )

  const { histogram, pngData } = geometryRaster || {}

  return (
    <Box>
      <img alt={`${year} CDL`} src={pngData} width="50" height="50" />
      <Stack>
        {histogram?.map((entry: any) => (
          <Typography variant="caption" key={entry.color}>
            <span
              style={{
                display: 'inline-block',
                backgroundColor: entry.paletteColor,
                width: 14,
                height: 14,
              }}
            ></span>{' '}
            {entry.label}: {(100 * entry.portion).toFixed(1)}%
          </Typography>
        ))}
      </Stack>
    </Box>
  )
}
